import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { GenericService } from '../../commons/generic.service';
import {HttpClient} from '@angular/common/http';
import { VerificaCampanhaResponseDto } from "../../model/verificaCampanhaResponseDto";


@Injectable()
export class CampanhasServidorService extends GenericService {

    private path = 'api/v1/campanha-servidor/verifica-realizar-campanha';

    constructor(http: HttpClient) {
        super(http);
    }

    verificarCampanhaBenseValores(): Observable<VerificaCampanhaResponseDto>{
        return this.getMethod(`${this.path}/bens-valores`);
    }

    verificarCampanhaRecadastramento(): Observable<VerificaCampanhaResponseDto>{
        return this.getMethod(`${this.path}/recadastramento`);
    }

}
